import * as React from "react";
import {
  TextField,
  Button,
  Stack,
  InputAdornment,
  Checkbox,
  Typography,
  Box,
} from "@mui/material";
import { Check, Save } from "@mui/icons-material";
import ModalUI from "../UI/ModalUI";
import useReportStore from "../../store/zustandStore/reportZs";
import { checkErrorYear } from "../../utils/validationData";

const ReportsPrintModalEditor = (props) => {
  const { createReportZs, updateReportZs } = useReportStore();
  const { data, isstatusnew, open } = props;
  const currentYear = new Date().getFullYear();
  const [state, setState] = React.useState({
    title: "",
    year: currentYear - 1,
    // autoChapter: false,
    description: "",
  });
  const [errorValues, setErrorValues] = React.useState([]);

  React.useEffect(() => {
    setErrorValues([]);
    setState({
      id: data.id ? data.id : "",
      title: data.title ? data.title : "",
      year: data.year ? data.year : currentYear - 1,
      // autoChapter: data.autoChapter ? data.autoChapter : false,
      description: data.description ? data.description : "",
      // status: data.status ? data.status : "ACTIVE",
    });
  }, [data, open]);

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if (name === "autoChapter") {
      setState({
        ...state,
        autoChapter: event.target?.checked ? event.target.checked : false,
      });
    } else {
      setState({ ...state, [name]: value ? value : "" });
    }
  };

  const saveUser = () => {
    var initialError = [];
    Object.keys(state).map(function (key, index) {
      if (state[key] !== "" || Object.keys(state[key]).length !== 0) {
      } else {
        initialError.push(key);
      }
    });

    setErrorValues(initialError);

    var initialErrorTemp = [];
    initialErrorTemp = initialError.filter((item) => item !== "id"); // remove id item

    if (initialErrorTemp.length === 0 && !checkErrorYear(state?.year)) {
      if (isstatusnew) {
        const { id, ...newReport } = state;
        createReportZs(newReport);
      } else {
        updateReportZs(state);
      }
      props.onClose();
    }
  };

  const checkError = (item) => {
    if (errorValues.find((element) => element === item)) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <ModalUI {...props}>
      <Stack spacing={2}>
        <TextField
          name="title"
          autoComplete="off"
          id="title"
          variant="outlined"
          error={checkError("title")}
          helperText={checkError("title") ? "Titulli është i detyruar" : null}
          InputProps={{
            startAdornment: (
              <InputAdornment
                sx={{
                  "&.MuiInputAdornment-root": {
                    minWidth: "100px",
                  },
                }}
                position="start"
              >
                Titull
              </InputAdornment>
            ),
          }}
          value={state.title}
          onChange={handleInputChange}
        />
      </Stack>
      <Stack spacing={2}>
        <TextField
          name="year"
          autoComplete="off"
          id="year"
          number
          variant="outlined"
          error={checkError("year") || checkErrorYear(state?.year)}
          helperText={
            checkErrorYear(state?.year)
              ? "Viti nuk është i saktë"
              : checkError("year")
              ? "Viti është i detyruar"
              : null
          }
          InputProps={{
            startAdornment: (
              <InputAdornment
                sx={{
                  "&.MuiInputAdornment-root": {
                    minWidth: "100px",
                  },
                }}
                position="start"
              >
                Viti
              </InputAdornment>
            ),
          }}
          value={state.year}
          onChange={handleInputChange}
        />
      </Stack>
      {/* <Stack>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Typography variant="h5" color="primary">
            Krijo Kapitujt automatikisht
          </Typography>
          <Checkbox
            name="autoChapter"
            id="autoChapter"
            defaultChecked={false}
            checked={state.autoChapter}
            onChange={handleInputChange}
            // {...props}
          ></Checkbox>
        </Box>
      </Stack> */}
      <Stack spacing={2}>
        <TextField
          name="description"
          autoComplete="off"
          id="description"
          variant="outlined"
          error={checkError("description")}
          helperText={
            checkError("description") ? "Përshkrimi është i detyruar" : null
          }
          InputProps={{
            startAdornment: (
              <InputAdornment
                position="start"
                sx={{
                  "&.MuiInputAdornment-root": {
                    minWidth: "100px",
                  },
                }}
              >
                Përshkrimi
              </InputAdornment>
            ),
          }}
          value={state.description}
          onChange={handleInputChange}
        />
      </Stack>
      <Stack sx={{ display: "flex", width: "100%" }}>
        <Button
          variant="contained"
          sx={{
            backgroundColor: "primary.dark",
            display: "flex",
            marginTop: "40px",
          }}
          startIcon={<Save />}
          onClick={saveUser}
        >
          {isstatusnew ? "Shto" : "Ndrysho"}
        </Button>
      </Stack>
    </ModalUI>
  );
};
export default ReportsPrintModalEditor;
